// @ts-strict-ignore
import React from 'react'
import PageContext from 'components/Layouts/V3/context'
import { StandardWidth } from 'services/styles'
import { useTheme } from '@mui/material/styles'
import { useMediaQuery } from './useMediaQuery'

export interface IPageStateHookResult {
  pageSidebarExists: boolean
  pageSidebarHidden: boolean
  pageSidebarOpen: boolean
  requiredSidebarWidth: StandardWidth
  setPageSidebarOpen: (value: boolean) => void
  setRequiredSidebarWidth: (value: StandardWidth | 'none') => void
  incrementPageSidebarCount: () => void
  decrementPageSidebarCount: () => void
}

/**
 * React hook to read and alter the state of the current Page layout.
 */
export function usePageState(): IPageStateHookResult {
  const {
    secondarySidebarOpen,
    requiredSidebarWidth,
    hasSecondarySidebar,
    setSecondarySidebarOpen,
    setRequiredSidebarWidth,
    incrementPageSidebarCount,
    decrementPageSidebarCount,
  } = React.useContext(PageContext)

  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(requiredSidebarWidth))

  return {
    pageSidebarExists: hasSecondarySidebar,
    pageSidebarHidden: isSmallScreen,
    pageSidebarOpen: secondarySidebarOpen,
    requiredSidebarWidth: requiredSidebarWidth,
    setPageSidebarOpen: setSecondarySidebarOpen,
    setRequiredSidebarWidth: setRequiredSidebarWidth,
    incrementPageSidebarCount: incrementPageSidebarCount,
    decrementPageSidebarCount: decrementPageSidebarCount,
  }
}
